import { fontList } from '@gelatoas/design-editor-fonts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import fontManager from './fontManager';
import addUploadedFontsReducer from './reducer/addUploadedFontsReducer';
import removeUploadedFontReducer from './reducer/removeUploadedFontReducer';
import setAvailableFontsReducer from './reducer/setAvailableFontsReducer';
import setDefaultFontStylesReducer from './reducer/setDefaultFontStylesReducer';
import setFontListReducer from './reducer/setFontListReducer';
import setFontUploadEnabledReducer from './reducer/setFontUploadEnabledReducer';
import setUploadedFontsReducer from './reducer/setUploadedFontsReducer';
import updateFontStatusReducer from './reducer/updateFontStatusReducer';
import { FontState } from './types';
import defaultFontStyles from './utils/defaultFontStyles';
import fontMetadataToFontDefinition from './utils/fontMetadataToFontDefinition';
import getOrderedFallbackFonts from './utils/getOrderedFallbackFonts';

export const fontsInitialState: FontState = {
  availableFonts: fontList.map(fontMetadataToFontDefinition),
  uploadedFonts: [],
  fontUploadEnabled: false,
  fontUploadButtonHidden: false,
  defaultFontStyles,
};

fontManager.fontDefinitions = getOrderedFallbackFonts(fontsInitialState.availableFonts);

const slice = createSlice({
  name: 'fonts',
  initialState: fontsInitialState,
  reducers: {
    setDefaultFontStylesAction: setDefaultFontStylesReducer,
    updateFontStatusAction: updateFontStatusReducer,
    setFontListAction: setFontListReducer,
    setAvailableFontsAction: setAvailableFontsReducer,
    setUploadedFontsAction: setUploadedFontsReducer,
    addUploadedFontsAction: addUploadedFontsReducer,
    removeUploadedFontAction: removeUploadedFontReducer,
    setFontUploadEnabledAction: setFontUploadEnabledReducer,
    setFontUploadButtonHiddenAction: (state: FontState, action: PayloadAction<boolean>) => {
      state.fontUploadButtonHidden = action.payload;
    },
  },
});

const { actions, reducer } = slice;

export const {
  setDefaultFontStylesAction,
  updateFontStatusAction,
  setFontListAction,
  setAvailableFontsAction,
  setUploadedFontsAction,
  addUploadedFontsAction,
  removeUploadedFontAction,
  setFontUploadEnabledAction,
  setFontUploadButtonHiddenAction,
} = actions;

export default reducer;
